/*
 * @Author: maomao
 * @Date:
 * @LastEditTime:
 * 不是我喜欢的样子你都有，而是你的样子我都很喜欢
 */
import axios from "axios"
//axios.defaults.baseURL='http://10.115.166.27:8050/'  //东华
axios.defaults.baseURL='http://182.43.16.164:8050/'  //浪潮 双碳
//axios.defaults.baseURL='http://182.43.16.164:8070/'  //浪潮  能管  服务器
//axios.defaults.baseURL='http://localhost:8070/'  //浪潮  能管  本地
// axios.defaults.baseURL='http://192.168.3.22:8050/'  //DEV
export const jiagong = () => {
  return axios.request({
    method: 'post',
    url: ''
  })
}

//碳排放
export function getEmissionData(query) {
  return axios.request({
    url: '/driver/getEmissionData',
    method: 'get',
    params: query
  })
}
//碳排放强度
export function getStrengthData(query) {
  return axios.request({
    url: '/driver/getStrengthData',
    method: 'get',
    params: query
  })
}
//重点设备配方量
export function getEvidenceData(query) {
  return axios.request({
    url: '/driver/getevidencedata',
    method: 'get',
    params: query
  })
}
//Top数据
export function getTopCommonData(query) {
  return axios.request({
    url: '/driver/gettopcommondata',
    method: 'get',
    params: query
  })
}
//Main数据
export function getTopMainData(query) {
  return axios.request({
    url: '/driver/gettopmaindata',
    method: 'get',
    params: query
  })
}
//碳履约/碳交易
export function getDealData(query) {
  return axios.request({
    url: '/driver/getdealdata',
    method: 'get',
    params: query
  })
}
//CCER数据
export function getCCERData(query) {
  return axios.request({
    url: '/driver/getccerData',
    method: 'get',
    params: query
  })
}

//外购电力
export function gerOutBuyPower(query) {
  return axios.request({
    url: '/driver/getbuyelectric',
    method: 'get',
    params: query
  })
}
//市场价格走势
export function getCCERDataApi(query) {
  return axios.request({
    url: '/driver2/getccerDataForCharts',
    method: 'get',
    params: query
  })
}
//CCER
export function getCCERListApi(query) {
  return axios.request({
    url: '/driver2/getccerDataList',
    method: 'get',
    params: query
  })
}
//所有 其他皆苦集合
export function getCenterDataForJApi(query) {
  return axios.request({
    url: '/driver/getCenterDataForJ',
    method: 'get',
    params: query
  })
}
//年度累计耗电量
export function getChildGroup5SumApi(query) {
  return axios.request({
    url: '/driver2/getChildGroup5Sum',
    method: 'get',
    params: query
  })
}



// WEBPACK FOOTER //
// ./src/api/api.js